import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SimpleChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'daui-pull-to-refresh',
  templateUrl: './pull-to-refresh.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pull-to-refresh.component.less'],
})
export class PullToRefreshComponent implements OnInit, OnChanges {
  @Input() isCompleted = false;
  @Input() disabled = false;
  @Output() inProgress: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() isCompletedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('indicator', { static: false }) indicator?: ElementRef;

  startY = 0;
  isStarted = false;
  activationProgressValue = 50;
  isInProgress = false;
  isRefreshArmed = false;

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {}

  @HostListener('document:mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    if (this.elementRef) {
      // see if clicked element is the target element
      if (this.isClickedInside(event)) {
        this.start(event.pageY, event);
      }
    }
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    this.move(event.pageY, event);
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.stop(event);
  }
  @HostListener('document:mouseleave', ['$event'])
  onMouseLeave(event: MouseEvent) {
    this.stop(event);
  }

  @HostListener('document:touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    if (this.elementRef) {
      // see if clicked element is the target element
      if (this.isClickedInside(event)) {
        this.start(event.touches[0].pageY, event);
      }
    }
  }
  @HostListener('document:touchmove', ['$event'])
  onTouchMove(event: TouchEvent) {
    this.move(event.touches[0].pageY, event);
  }
  @HostListener('document:touchcancel', ['$event'])
  onTouchCancel(event: TouchEvent) {
    this.stop(event);
  }
  @HostListener('document:touchend', ['$event'])
  onTouchEnd(event: TouchEvent) {
    this.stop(event);
  }

  start(value: number, event: Event) {
    if (this.disabled) {
      return;
    }

    if (this.isInProgress) {
      return;
    }

    event.stopPropagation();
    event.stopImmediatePropagation();

    this.startY = value;
    this.isStarted = true;
  }

  move(value: number, event: Event) {
    if (this.disabled) {
      return;
    }
    if (this.isStarted) {
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (value > this.startY) {
        let delta = value - this.startY;
        const t = delta / this.activationProgressValue;
        const deltaIndicator = Math.abs(this.easeInOutQuart(t) * delta);

        delta = Math.abs(this.easeInOutQuart(t) * delta) * 10;

        if (this.indicator) {
          this.indicator.nativeElement.style.height =
            (delta > this.activationProgressValue
              ? this.activationProgressValue / 10
              : deltaIndicator) + 'rem';
        }
        if (delta >= this.activationProgressValue) {
          this.progress();
        }
      }
    }
  }

  stop(event: Event) {
    if (!this.disabled && (this.isInProgress || this.isStarted)) {
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
    this.reset();
  }
  reset() {
    if (this.disabled || this.isInProgress) {
      return;
    }
    if (this.indicator) {
      this.indicator.nativeElement.style.height = 0;
    }
    this.isStarted = false;
    this.isCompleted = false;
    this.inProgress.emit(false);
    this.isCompletedChange.emit(true);
  }
  progress() {
    this.isInProgress = true;
    this.isStarted = false;
    this.isRefreshArmed = true;
    this.inProgress.emit(true);
    this.isCompletedChange.emit(false);
  }
  easeInOutQuart(t: number) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
  }

  isClickedInside(event: Event): boolean {
    return event.target instanceof Node && this.elementRef.nativeElement.contains(event.target);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // tslint:disable-next-line: forin
    for (const propName in changes) {
      switch (propName) {
        case 'isCompleted':
          if (this.isCompleted) {
            this.isInProgress = false;
            this.isRefreshArmed = false;
            this.reset();
          }
          break;
      }
    }
  }
}
